import styled from "styled-components";
import colors from "../../../assets/styles/colors";

export const PlansContainer = styled.div`
  height: 100%;
`;

export const PlansHeader = styled.div`
  display: flex;
  margin-top: 15px;
  margin-bottom: 15px;
  align-items: center;
`;

export const PlansHeaderIcon = styled.div`
  background-color: ${colors.bgTertiary};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 64px;
  height: 64px;
  border-radius: 16px;
  box-shadow: ${colors.bgTertiaryShadow};
`;

export const PlansHeaderInfo = styled.div`
  color: ${colors.textPrimary};
  font-size: 16px;
  line-height: 23px;
  margin-left: 15px;
`;

export const PlansContent = styled.div`
  width: 100%;
  max-width: 800px;
  padding-top: 20px;
  padding-bottom: 20px;
`;

export const PlansTable = styled.div``;

export const PlansTableHeader = styled.div`
  width: 100%;
  display: flex;
  background-color: ${colors.textPrimary};
`;

export const PlansTableCol = styled.div`
  width: ${prop => prop.width};
  color: ${prop => prop.color};
  padding: 10px;
  font-size: 14px;
  line-height: 22px;
  font-weight: bold;
  
  &:first-child {
    font-weight: normal;
  }
`;

export const PlansTableBody = styled.div`
  width: 100%;
  display: flex;
`;

export const PlansTableFooter = styled.div`
  width: 100%;
  display: flex;
  background-color: ${colors.textPrimary};  
`;

export const PlansCheckboxContent = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
`;

export const PlansCheckboxShow = styled.div`
  width: 14px;
  height: 14px;
  border-radius: 7px;
  padding: 2px;
  background: ${colors.white};
  border: 1px solid ${prop => prop.selected ? colors.textHyperlink : colors.grayLight};
  position: relative;
  transition: ease-in-out .2s;

  &:after {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    width: 8px;
    border-radius: 7px;
    height: 8px;
    background: ${prop => prop.selected ? colors.textHyperlink : colors.white};
  }
`;

export const PlansCheckboxInput = styled.input`
  width: 0px;
  height: 0px;
  border: 0;
`;

export const PlansCheckboxLabel = styled.label`
  margin-left: 8px;
  color: ${colors.textPrimary};
  font-size: 14px;
  line-height: 18px;
`;

export const PlansTableIcon = styled.div`
  width: 16px;
  height: 16px;
  background: ${prop => prop.background};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
`;

export const PlansTableValue = styled.span`
  color: ${colors.textPrimary};
  font-size: 14px;
  line-height: 22px;
`;
